import {
  AlertIcon,
  CometIcon,
  DashboardIcon,
  EditStarIcon,
  IntegrationIcon,
  LandingIcon,
  MessageEditIcon,
  QuestionIcon,
  UserBoltIcon,
} from '@/shared/ui';

export const benefits = [
  {
    Icon: CometIcon,
    heading: 'Automated Review Requests',
    description: 'Send review requests and follow-ups automatically.',
  },
  {
    Icon: UserBoltIcon,
    heading: 'Automated Referral Requests',
    description: 'Invite customers for referrals with automated follow-ups.',
  },
  {
    Icon: EditStarIcon,
    heading: 'Manual Review Requests',
    description: 'Send review requests manually whenever needed.',
  },
  {
    Icon: MessageEditIcon,
    heading: 'Personalized SMS/Email Templates',
    description: 'Customize your SMS and email templates to match your brand.',
  },
  {
    Icon: QuestionIcon,
    heading: 'Custom Pre-Request Questions',
    description: 'Add tailored questions to collect detailed feedback.',
  },
  {
    Icon: AlertIcon,
    heading: 'Negative Feedback Alerts',
    description:
      'Catch negative feedback from pre-review surveys before it goes public and get notified immediately to address issues.',
  },
  {
    Icon: LandingIcon,
    heading: 'Review Showcase Microsite',
    description: 'Display your reviews on a microsite to build trust and generate leads.',
  },
  {
    Icon: DashboardIcon,
    heading: 'Campaign Analytics',
    description: 'Monitor and analyze your review campaigns with clear insights.',
  },
  {
    Icon: IntegrationIcon,
    heading: 'Native & Custom Integrations',
    description:
      'Connect seamlessly with CRM, payment systems, and other tools to streamline your workflow.',
  },
];
